import store from '../store/store';
import { mutatorAction } from 'satcheljs';
/**
 * Called when we change working hours end time
 * @timeInMinutes: new value for end time in minutes
 */
export default mutatorAction('setWorkingHoursEndTimeOption', function (timeInMinutes) {
    var optionState = store();
    optionState.workingHoursEndTime = timeInMinutes;
});
//# sourceMappingURL=setWorkingHoursEndTimeOption.js.map